"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/** 积分相关（独立于营销 /marketing） */
var integralRouter = {
  path: '/integral',
  component: _layout.default,
  redirect: '/integral/exchangeConfig',
  name: 'IntegralRoot',
  meta: {
    title: '积分',
    icon: 'clipboard'
  },
  children: [{
    path: '',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/integral/index'));
      });
    },
    name: 'Integral',
    meta: {
      title: '积分',
      icon: ''
    },
    redirect: 'exchangeConfig',
    children: [{
      path: 'integralconfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/integral/config/index'));
        });
      },
      name: 'integralConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'integrallog',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/marketing/integral/integralLog/index'));
        });
      },
      name: 'integralLog',
      meta: {
        title: '积分日志',
        icon: ''
      }
    }, {
      path: 'pointsActivity',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/pointsActivity/index'));
        });
      },
      name: 'pointsActivity',
      meta: {
        title: '积分获取配置',
        icon: ''
      }
    }, {
      path: 'exchangeConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/exchangeConfig/index'));
        });
      },
      name: 'exchangeConfig',
      meta: {
        title: '积分兑换配置',
        icon: ''
      }
    }, {
      path: 'userPointsManage',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/userPointsManage/index'));
        });
      },
      name: 'userPointsManage',
      meta: {
        title: '用户积分管理',
        icon: ''
      }
    }, {
      path: 'systemConfig',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/systemConfig/index'));
        });
      },
      name: 'integralSystemConfig',
      meta: {
        title: '积分系统配置',
        icon: ''
      }
    }, {
      path: 'exchangeConfig/save/:mode/:id?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/exchangeConfig/operate'));
        });
      },
      name: 'exchangeConfigOperate',
      hidden: true,
      meta: {
        title: '积分兑换配置',
        noCache: true,
        activeMenu: '/integral/exchangeConfig'
      }
    }, {
      path: 'pointsActivity/save/:mode/:id?',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/pointsActivity/operate'));
        });
      },
      name: 'pointsActivityOperate',
      hidden: true,
      meta: {
        title: '积分兑换配置操作',
        noCache: true,
        activeMenu: '/integral/pointsActivity'
      }
    }, {
      path: 'exchangeConfig/goods/:activityId',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/goodsManage/index'));
        });
      },
      name: 'exchangeGoodsManage',
      hidden: true,
      meta: {
        title: '积分商品管理',
        noCache: true,
        activeMenu: '/integral/exchangeConfig'
      }
    }, {
      path: 'pointsActivity/goods/:activityId',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/integral/goodsManage/index'));
        });
      },
      name: 'pointsGoodsManage',
      hidden: true,
      meta: {
        title: '积分商品管理',
        noCache: true,
        activeMenu: '/integral/pointsActivity'
      }
    }]
  }]
};
var _default = exports.default = integralRouter;